import * as Yup from 'yup';

const SCHEMA1 = Yup.object().shape({
  DuelTitle: Yup.string().required('وارد کردن عنوان تورنومنت الزامی است'),
  DuelImageBanner: Yup.string().required('انتخاب عکس بنر الزامی است'),
  DuelMinimumScore: Yup.number().typeError('لطفا حداقل امتیاز کاربر را بصورت عدد مثبت وارد کنید'),
});

const SCHEMA2 = Yup.object().shape({
  DuelAmount: Yup.number().typeError('لطفا هزینه قابل پرداخت را بصورت عدد مثبت وارد کنید').positive('مقدار باید مثبت باشد'),
});

const SCHEMA3 = Yup.object().shape({
  DuelTermsAgreement: Yup.string().required('وارد کردن متن توضیحات الزامی است').max(1500, 'حداکثر کاراکتر 1500'),
});

const SCHEMA4 = Yup.object().shape({
  PopupURL: Yup.string().required('وارد کردن آدرس ارجاع بر روی اعلان الزامی است'),
  DuelPopupImageFile: Yup.string().required('انتخاب تصویر اعلان الزامی است'),
});

export { SCHEMA1, SCHEMA2, SCHEMA3, SCHEMA4 };
